<div class="py-4 container-fluid schedule-correction-page">
  <div class="schedule-correction-header">
    <div>
      <h4 class="schedule-correction-title">ตรวจสอบคำขอแก้ไขตารางสอนหลังรับรอง</h4>
    </div>
  </div>

  <div class="schedule-correction-card">
    <div class="schedule-correction-card-body">
      <div class="schedule-correction-toolbar" [formGroup]="filterForm">
        <div class="schedule-correction-filter">
          <app-select
            label="เทอมการศึกษา"
            formControlName="academicTerm"
            [options]="academicTermOptions"
            [searchable]="false"
            [clearable]="false"
            inputClass="schedule-correction-select"
            classes="mb-0"
          ></app-select>
        </div>
        <div class="schedule-correction-filter">
          <app-select
            label="ปีการศึกษา"
            formControlName="year"
            [options]="yearOptions"
            [searchable]="false"
            [clearable]="false"
            inputClass="schedule-correction-select"
            classes="mb-0"
          ></app-select>
        </div>
        <div class="schedule-correction-search">
          <app-filter-search-input
            label="ชื่อ - นามสกุล"
            formControlName="keywords"
            inputClass="schedule-correction-search-input"
            ariaLabel="ค้นหาคำขอแก้ไขหลังการรับรอง"
            classes="mb-0"
            (searchSubmit)="onSearch()"
          ></app-filter-search-input>
        </div>
      </div>

      <div class="segmented-tabs segmented-tabs--sm schedule-correction-tabs" role="tablist" aria-label="สถานะคำขอแก้ไขหลังการรับรอง">
<button [attr.aria-selected]="activeTab() === 'all'" role="tab"
          type="button"
          class="segmented-tab schedule-correction-tab"
          [class.active]="activeTab() === 'all'"
          (click)="onTabChange('all')"
        >
          รายการทั้งหมด
        </button>
<button [attr.aria-selected]="activeTab() === 'pending'" role="tab"
          type="button"
          class="segmented-tab schedule-correction-tab"
          [class.active]="activeTab() === 'pending'"
          (click)="onTabChange('pending')"
        >
          รอดำเนินการ
        </button>
<button [attr.aria-selected]="activeTab() === 'approved'" role="tab"
          type="button"
          class="segmented-tab schedule-correction-tab"
          [class.active]="activeTab() === 'approved'"
          (click)="onTabChange('approved')"
        >
          อนุมัติแล้ว
        </button>
<button [attr.aria-selected]="activeTab() === 'rejected'" role="tab"
          type="button"
          class="segmented-tab schedule-correction-tab"
          [class.active]="activeTab() === 'rejected'"
          (click)="onTabChange('rejected')"
        >
          ปฏิเสธ
        </button>
      </div>

      <ng-template #rowIndexTemplate let-row="row">
        {{ row.sequence ?? '-' }}
      </ng-template>

      <ng-template #statusTemplate let-row="row">
        <span class="schedule-correction-status" [ngClass]="statusBadgeClass(row.status)">
          {{ row.statusLabel }}
        </span>
      </ng-template>

      <ng-template #actionTemplate let-row="row">
        <div class="schedule-correction-actions">
          <button
            type="button"
            class="btn schedule-correction-action-button datatable-view-action-button"
            aria-label="ดูรายละเอียดคำขอแก้ไขหลังการรับรอง"
            (click)="onView(row)"
          >
            <img
              src="assets/media/icons/svg/eye.svg"
              class="schedule-correction-action-icon datatable-view-action-icon"
              alt=""
              aria-hidden="true"
            />
          </button>
        </div>
      </ng-template>

      <app-datatable
        [datasource]="datasource()"
        [columns]="columns"
        [isLoading]="tableLoading()"
        [limit]="50"
        [showOrder]="false"
        (sortChange)="onSortChange($event)"
      ></app-datatable>

      <app-table-pagination
        [page]="datasource().page"
        [limit]="datasource().limit"
        [total]="datasource().total"
        [totalPage]="datasource().total_page"
        [offset]="datasource().offset"
        [dataLength]="datasource().data.length"
        [isLoading]="tableLoading()"
        [pageSizeOptions]="pageSizeOptions"
        ariaLabel="schedule correction requests pagination"
        (pageChange)="onPageChange($event)"
        (limitChange)="onLimitChange($event)"
      ></app-table-pagination>
    </div>
  </div>
</div>

<div *ngIf="detailOpen()" class="schedule-correction-modal-overlay" role="presentation">
  <section
    class="schedule-correction-modal-panel"
    role="dialog"
    aria-modal="true"
    aria-labelledby="scheduleCorrectionDetailTitle"
  >
    <ng-container *ngIf="selectedRequest() as request">
      <header class="schedule-correction-modal-header">
        <div class="schedule-correction-modal-title-row">
          <h5 id="scheduleCorrectionDetailTitle">
            {{ request.new_course_request_note && (request.items ?? []).length === 0
              ? 'รายละเอียดคำขอเพิ่มรายวิชาใหม่'
              : 'รายละเอียดคำขอแก้ไขหลังการรับรอง' }}
          </h5>
          <span class="schedule-correction-status" [ngClass]="statusBadgeClass(request.status)">
            {{ statusDisplayLabel(request.status, request.status_label) }}
          </span>
        </div>
        <button type="button" class="btn-close" aria-label="ปิด" (click)="onCloseDetail()"></button>
      </header>

      <div class="schedule-correction-modal-body">
        <section class="schedule-correction-detail-section">
          <h6>ข้อมูลผู้ส่งคำขอ</h6>
          <div class="schedule-correction-detail-grid">
            <div class="schedule-correction-detail-item">
              <strong>ชื่อ - นามสกุล :</strong>
              <span>{{ teacherDisplayName(request) }}</span>
            </div>
            <div class="schedule-correction-detail-item">
              <strong>อีเมล :</strong>
              <span>{{ displayValue(request.schedule_submission?.teacher?.email ?? request.requested_by?.email) }}</span>
            </div>
            <div class="schedule-correction-detail-item">
              <strong>ภาคการศึกษา :</strong>
              <span>{{ displayValue(request.schedule_submission?.academic_term?.name) }}</span>
            </div>
            <div class="schedule-correction-detail-item">
              <strong>ปีการศึกษา :</strong>
              <span>{{ formatAcademicYear(request.schedule_submission?.academic_term?.year) }}</span>
            </div>
            <div class="schedule-correction-detail-item">
              <strong>วันที่ส่งคำขอ :</strong>
              <span>{{ formatDateTime(request.requested_at) }}</span>
            </div>
          </div>
        </section>

        <section class="schedule-correction-detail-section">
          <h6>รายวิชาที่ต้องการแก้ไข</h6>
          <div *ngIf="(request.items ?? []).length === 0" class="schedule-correction-empty-state">
            ไม่มีรายวิชาเดิมที่ขอแก้ไข
          </div>
          <div class="schedule-correction-course-list">
            <div
              *ngFor="let item of request.items ?? []"
              class="schedule-correction-course-item"
            >
              <h6>รายละเอียดรายวิชา</h6>
              <div class="schedule-correction-course-grid">
                <div class="schedule-correction-detail-item">
                  <strong>รหัสวิชา :</strong>
                  <span>{{ itemSubjectCode(item) }}</span>
                </div>
                <div class="schedule-correction-detail-item">
                  <strong>ชื่อรายวิชา :</strong>
                  <span>{{ itemSubjectName(item) }}</span>
                </div>
                <div class="schedule-correction-detail-item">
                  <strong>Section :</strong>
                  <span>{{ displayValue(item.section ?? item.approvable?.section) }}</span>
                </div>
                <div class="schedule-correction-detail-item">
                  <strong>ประเภทการสอน :</strong>
                  <span>{{ itemTeachingType(item) }}</span>
                </div>
                <div class="schedule-correction-detail-item">
                  <strong>รูปแบบภาระงาน :</strong>
                  <span>{{ workloadSplitLabel(item) }}</span>
                </div>
                <div
                  *ngIf="teachingSlots(item).length > 0; else noTeachingSlots"
                  class="schedule-correction-detail-block schedule-correction-course-slots"
                >
                  <strong>วันสอน / ช่วงเวลาสอน :</strong>
                  <span class="schedule-correction-slot-list">
                    <span *ngFor="let slot of teachingSlots(item)">{{ teachingSlotLabel(slot) }}</span>
                  </span>
                </div>
                <ng-template #noTeachingSlots>
                  <div class="schedule-correction-detail-item">
                    <strong>วันสอน :</strong>
                    <span>-</span>
                  </div>
                  <div class="schedule-correction-detail-item">
                    <strong>ช่วงเวลาสอน :</strong>
                    <span>-</span>
                  </div>
                  <div class="schedule-correction-detail-item">
                    <strong>ห้องเรียน :</strong>
                    <span>-</span>
                  </div>
                </ng-template>
              </div>
              <div class="schedule-correction-course-note">
                <strong>เหตุผลของรายวิชานี้ :</strong>
                <p>{{ courseReasonDisplay(request, item) }}</p>
              </div>
            </div>
          </div>
        </section>

        <section class="schedule-correction-detail-section">
          <h6>ขอเพิ่มรายวิชาใหม่</h6>
          <div class="schedule-correction-detail-block">
            <strong>รายละเอียด :</strong>
            <p>{{ newCourseRequestDetail(request) }}</p>
          </div>
        </section>

        <section class="schedule-correction-detail-section">
          <h6>ผลการพิจารณา</h6>
          <div class="schedule-correction-detail-grid">
            <div class="schedule-correction-detail-item">
              <strong>ผู้พิจารณา :</strong>
              <span>{{ buildPersonDisplayName(request.reviewed_by?.academic_rank, request.reviewed_by?.full_name) }}</span>
            </div>
            <div class="schedule-correction-detail-item">
              <strong>วันที่พิจารณา :</strong>
              <span>{{ formatDateTime(request.reviewed_at) }}</span>
            </div>
            <div class="schedule-correction-detail-item">
              <strong>ผลการพิจารณา :</strong>
              <span class="schedule-correction-status" [ngClass]="statusBadgeClass(request.status)">
                {{ statusDisplayLabel(request.status, request.status_label) }}
              </span>
            </div>
            <div class="schedule-correction-detail-item">
              <strong>ความคิดเห็น :</strong>
              <span>{{ displayValue(request.vice_dean_comment) }}</span>
            </div>
          </div>
        </section>
      </div>

      <footer class="schedule-correction-modal-footer">
        <button
          *ngIf="canReview(request)"
          type="button"
          class="btn schedule-correction-danger-button"
          [disabled]="actionLoading()"
          (click)="onOpenReject()"
        >
          ปฏิเสธ
        </button>
        <button
          *ngIf="canReview(request)"
          type="button"
          class="btn schedule-correction-primary-button"
          [disabled]="actionLoading()"
          (click)="onOpenApprove()"
        >
          อนุมัติ
        </button>
        <button
          *ngIf="!canReview(request)"
          type="button"
          class="btn schedule-correction-back-button"
          (click)="onCloseDetail()"
        >
          ปิด
        </button>
      </footer>
    </ng-container>
  </section>
</div>

<app-confirm-dialog
  #approveDialog
  modalId="scheduleCorrectionApproveDialog"
  title="ต้องการอนุมัติคำขอแก้ไขตารางสอนหลังรับรองนี้ใช่หรือไม่ ?"
  message="เมื่อได้รับการอนุมัติแล้ว หัวหน้างานการศึกษาจะสามารถดำเนินการแก้ไขข้อมูลรายวิชาดังกล่าวได้"
  cancelText="ยกเลิก"
  confirmText="อนุมัติ"
  icon="warning"
  [isProcessing]="actionLoading()"
  [stackAboveModal]="true"
  (confirmed)="onConfirmApprove()"
  (cancelled)="onCloseApprove()"
></app-confirm-dialog>

<app-confirm-dialog
  #successDialog
  modalId="scheduleCorrectionSuccessDialog"
  [title]="successTitle()"
  [message]="successMessage()"
  confirmText="ปิด"
  icon="success"
  [showCancelButton]="false"
  [stackAboveModal]="true"
  (confirmed)="successDialog.close()"
></app-confirm-dialog>

<app-confirm-dialog
  #errorDialog
  modalId="scheduleCorrectionErrorDialog"
  title="ไม่สามารถดำเนินการได้"
  [message]="errorMessage()"
  confirmText="ปิด"
  icon="error"
  [showCancelButton]="false"
  [stackAboveModal]="true"
  (confirmed)="errorDialog.close()"
></app-confirm-dialog>

<div *ngIf="rejectOpen()" class="schedule-correction-modal-overlay schedule-correction-modal-overlay-stacked" role="presentation">
  <section
    class="schedule-correction-review-panel"
    role="dialog"
    aria-modal="true"
    aria-labelledby="scheduleCorrectionRejectTitle"
  >
    <header class="schedule-correction-modal-header">
      <h5 id="scheduleCorrectionRejectTitle">กรุณาระบุเหตุผลที่ปฏิเสธคำขอแก้ไข</h5>
      <button type="button" class="btn-close" aria-label="ปิด" (click)="onCloseReject()"></button>
    </header>
    <form class="schedule-correction-review-body" [formGroup]="rejectForm" (ngSubmit)="onConfirmReject()">
      <app-textarea
        label="เหตุผลที่ปฏิเสธ"
        formControlName="comment"
        [rows]="5"
        [required]="true"
        [error]="rejectForm.controls.comment.invalid && rejectForm.controls.comment.touched ? rejectForm.controls.comment.errors : null"
        classes="mb-0"
      ></app-textarea>
      <footer class="schedule-correction-modal-footer">
        <button type="button" class="btn schedule-correction-back-button" [disabled]="actionLoading()" (click)="onCloseReject()">ยกเลิก</button>
        <button type="submit" class="btn schedule-correction-danger-button" [disabled]="actionLoading()">
          {{ actionLoading() ? 'กำลังดำเนินการ...' : 'ยืนยันปฏิเสธ' }}
        </button>
      </footer>
    </form>
  </section>
</div>
